import React from 'react';
import Icon, {ICON_NAME} from "../../Icon";
import {useTrackingOp} from "../../../contexts/TrackingOpContext";

const Note: React.FC = () => {
    const [note] = useTrackingOp(state => state.op?.operation.note);

    if (!note)
        return null;

    return <div>
        <div className='flex items-center gap-1'>
            <Icon icon={ICON_NAME.NOTE} size='large'/>
            <span className='font-[600]'>Note:</span>
        </div>
        <div>
            {note}
        </div>
    </div>;
};

export default Note;